  
export function isEmail(value) {
  if (!value) return false;
  const valid = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
  return valid.test(value);
}
    
export function isPhone(value) {
  if (!value) return false;
  const valid = new RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, "gm");
  return valid.test(value);
}
  
export function isUrl(value) {
  if (!value) return false;
  const valid = new RegExp(/(https?:\/\/)[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/, "gm");
  return valid.test(value);
}
